/**
 *
 * @module sessionEntitlement
 *
 */

import Check from 'check-types';
import Exception from './../exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class SessionEntitlement
 * @desc Represents the session entitlement data provided by the service.
 *
 */
export default class SessionEntitlement {

    /**
     *
     * @param {String} name
     *
     */
    constructor(name) {

        const errorMessage = {
            ctor: 'SessionEntitlement(name)',
            get name() {
                return `${this.ctor} name should be a String with length`;
            }
        };

        nonEmptyString(name, errorMessage.name, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.name = name;

    }

}



// WEBPACK FOOTER //
// ./src/services/session/sessionEntitlement.js